import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import config from "./config";
import { ApplicationContextProvider } from "./context/GlobalState";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

Amplify.configure(config.amplify);
console.log("[LOG] - Amplify configured for DCL brand app.");

/**
 * Bootstrap the React application tree.
 * Translation: Bootstrap the React application tree.
 */
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <ApplicationContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApplicationContextProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
serviceWorkerRegistration.unregister();
